<div class="row d-flex flex-row mt-5">
  <span class="text-base font-semibold mb-3 p-0 card-title">{{
    getDisplayName(fields)
  }}</span>
  <div class="separator"></div>
</div>
